import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-delete-incident-warning",
	templateUrl: "./delete-incident-warning.component.html",
	styleUrls: ["./delete-incident-warning.component.css"],
})
export class DeleteIncidentWarningComponent implements OnInit {
	constructor(public ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onYes() {
		this.ref.close(1);
	}

	onNo() {
		this.ref.close(0);
	}

	onCancel() {
		this.ref.close(-1);
	}

	///////////////////////////////
}
